import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  event: {},
  config: {},
};

const slice = createSlice({
  name: 'event',
  initialState,
  reducers: {
    updateEvent: (state, action) => {
      state.event = action.payload;
    },
    updateItems: (state, action) => {
      state.event = { ...state.event, items: action.payload };
    },
    updateConfig: (state, action) => {
      state.config = { ...state.config, ...action.payload };
    },
  },
});

export const { updateEvent, updateItems, updateConfig } = slice.actions;
export default slice.reducer;
